import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es.json';
import en from './en.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: localStorage.getItem('frostbound_lang') || 'es',
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', (lang) => {
  localStorage.setItem('frostbound_lang', lang);
});

export default i18n;
